import classNames from 'clsx';
import React from 'react';

import useWizardLoading from '@swf/core/hooks/useWizardLoading';
import type { ClassNameProp } from '@swf/core/types/Props';

import FirstLoader from '../../../FirstLoader/FirstLoader';
import TransactionLoader from '../../../TransactionLoader/TransactionLoader';

import { gridLayout, page } from './Page.scss';

export type Props = Partial<ClassNameProp> & { applyGridLayout?: boolean; loading?: boolean };

const Page: React.FunctionComponent<Props> = ({
  children,
  className,
  applyGridLayout,
  loading
}) => {
  const { loading: serviceLoading, service } = useWizardLoading();
  const isWithdrawProcess = service?.includes('withdraw.cashout-process');

  return (
    <div className={classNames(page, className, { [gridLayout]: applyGridLayout })}>
      {(serviceLoading && isWithdrawProcess) || loading ? (
        <FirstLoader />
      ) : (
        <>
          {children}
          <TransactionLoader />
        </>
      )}
    </div>
  );
};

export default Page;
